import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3152ROLES } from '../../../U3152';
import type { U3152ContactTypeFormRow } from '../../../U3152Service';

export type U3152ContactTypeFormToolbarHandlers = U2000FormStateHandlersReturn<U3152ContactTypeFormRow> & {
  addNewContactType: () => void;
  modifyContactType: () => void;
  deleteContactType: () => void | Promise<void>;
};

interface U3152ContactTypeFormToolBarProps {
  formStateHandlers: U3152ContactTypeFormToolbarHandlers;
}

export const U3152ContactTypeFormToolBar: React.FC<U3152ContactTypeFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3152ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewContactType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3152ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyContactType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3152ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteContactType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
